const texts = [{
    lang: "fa",
    data: [{
        item: "mainTitle",
        data: 'آجیل حسن پور'
    },
    {
        item: "menu",
        data: [
            {
                label: "صفحه اصلی",
                href: "/",
                icon: 'home',
                isActive: false,
            },
            {
                label: "محصولات",
                href: "/products",
                icon: 'products',
                isActive: false,
            },
            {
                label: "مجله سلامت",
                href: "/articels",
                icon: 'articels',
                isActive: false,
            },
            {
                label: "درباره ما",
                href: "/AboutUs",
                icon: 'about',
                isActive: false,
            },
            {
                label: "تماس با ما",
                href: "/ContactUs",
                icon: 'contact',
                isActive: false,
            },
        ]
    },
    {
        item: "footer",
        data: {
            linkTitle: "لینک ها",
            addressSection: "راه های ارتباط با ما",
            namadText: "نمادهای اطمینان",
            emailText: "ایمیل",
            followText: "ما را در شبکه های اجتماعی دنبال کنید.",
            link1: 'مجله سلامت',
            link2: 'درباره ما',
            link3: 'محصولات',
            link4: 'تماس با ما',
            link5: 'صفحه اصلی',
            link1Href: '/articels',
            link2Href: '/AboutUs',
            link3Href: '/products',
            link4Href: '/ContactUs',
            link5Href: '/',
            loadingText: 'در حال بار‌گذاری...',
        }
    },
    {
        item: "header",
        data: {
            mainTitle: "آجیل و خشکبار حسن پور",
            slogan: "با بیش از ۶۰ سال سابقه درخشان در صنعت آجیل",
            searchText: "جستجوی محصول",
            lang: 'زبان',
            accountBtn: "حساب کاربری",
        }
    },
    {
        item: "aboutUs",
        data: {
            title: "درباره ما",
            aboutText: "درباره آجیل حسن پور",
            faqsTitle: "سوالات متداول",
            whyText: "چرا آجیل حسن پور؟",
        }
    },
    {
        item: "contactUs",
        data: {
            title: "تماس باما",
            address: "آدرس",
            workTime: "ساعت کاری",
            telephone: "تلفن",
            email: "ایمیل",
            storePlace: "مکان فروشگاه",
            fullname: "نام و نام خانوادگی",
            tel: "شماره تلفن همراه",
            msg: "متن پیام",
            limit: "*حداکثر 160 کاراکتر",
            send: "ارسال"
        }
    },
    {
        item: "homepage",
        data: {
            mainTitle: "آجیل و خشکبار حسن پور",
            slogan: "با بیش از ۶۰ سال سابقه درخشان در صنعت آجیل",
            searchText: "جستجوی محصول",
            bestSalesTitle: "پر فروش ترین محصولات",
            instaboxText: "صفحه اینستاگرام ما را دنبال کنید",
            magBoxtitle: "زندگی شاد در گرو بدنی شاد",
            magBoxSecondTitlte: "ارمغان ما برای شما تازه ترین مواد اولیه است",
            articelsBoxTitle: "مجله سلامت",
            newestBoxTitle: "جدیدترین محصولات",
        }
    },
    {
        item: "adminMenu",
        data: [
            {
                label: "پروفایل مدیریت",
                value: "isProfile",
                icon: "profile",
                visible: true,
                isActive: false,
            },
            {
                label: "مدیریت فاکتور ها",
                value: "isFactors",
                icon: "factors",
                visible: true,
                isActive: false,
            },
            {
                label: "مدیریت محصولات",
                value: "isProducts-List",
                icon: "products",
                visible: true,
                isActive: false,
            },
            {
                label: "ویرایش محصول",
                value: "isProducts-Edit",
                icon: "products",
                visible: false,
                isActive: false,
            },
            {
                label: "افزودن محصول",
                value: "isProducts-Insert",
                icon: "products",
                visible: false,
                isActive: false,
            },
            {
                label: "مدیریت کاربران",
                value: "isUsers",
                icon: "users",
                visible: true,
                isActive: false,
            },
            {
                label: "مدیریت پیام ها",
                value: "isMessages",
                icon: "messages",
                visible: true,
                isActive: false,
            },
            {
                label: "مدیریت صفحات ثابت",
                value: "isPageManager",
                icon: "pageManager",
                visible: false,
                isActive: false,
            },
            {
                label: "مشاهده نظرات",
                value: "isComments",
                icon: "comments",
                visible: true,
                isActive: false,
            },
            {
                label: "مدیریت مجله سلامت",
                value: "isHealth",
                icon: "magazine",
                visible: true,
                isActive: false,
            },
            {
                label: "نشان شده ها",
                value: "isBookmarks",
                icon: "bookmarks",
                visible: true,
                isActive: false,
            },
        ],
    },
    {
        item: "productList",
        data: {
            mainCatTitle: "دسته بندی محصولات ",
            subCat: 'دسته های زیر مجموعه',
            sortText: 'مرتب سازی',
            searchText: "جستجو محصول",
            ascSort: 'صعودی',
            desSort: 'نزولی',
            emptyProducts: 'هیچ محصولی یافت نشد.',
            rangeSelectTitle: 'النطاق السعري المستهدف',
            loadingText: 'در حال بارگزاری...',
        }
    },
    {
        item: "articlesList",
        data: {
            mainCatTitle: "دسته بندی مقالات ",
            searchText: "جستجو مقاله",
            emptyArticels: 'هیچ مقاله ای برای نمایش وجود ندارد.',
            loadingText: 'در حال بارگزاری...',
        }
    },
    {
        item: "productDetail",
        data: {
            propertiesTitle: "خواص",
            related: "محصولات مشابه ",
            selectWeight: "انتخاب وزن",
            package1Title: "250 گرم",
            package2Title: "500 گرم",
            package3Title: "۱ کیلوگرم",
            outOfStockSelectedWeight: "موجود نیست.",
            outOfStock: "این محصول موجود نمی باشد.",
        }
    },
    {
        item: "articleDetail",
        data: {
            mainCatTitle: 'دسته بندی مقالات',
            date: "منتشر شده در تاریخ ",
            who: 'توسط',
            short: 'چکیده مقاله',
            text: 'متن مقاله',
            share: 'اشتراک گذاری مقاله'
        }
    },
    ]
},
{
    lang: "ar",
    data: [{
        item: "mainTitle",
        data: 'المكسرات الحسن پور'
    },
    {
        item: "menu",
        data: [
            {
                label: "الصفحة الأصلية",
                href: "/ar",
                icon: 'home',
                isActive: false,
            },
            {
                label: "منتجات",
                href: "/products",
                icon: 'products',
                isActive: false,
            },
            {
                label: "مجلة الصحة",
                href: "/articels",
                icon: 'articels',
                isActive: false,
            },
            {
                label: "معلومات عنا",
                href: "/ar/AboutUs",
                icon: 'about',
                isActive: false,
            },
            {
                label: "اتصل بنا",
                href: "/ar/ContactUs",
                icon: 'contact',
                isActive: false,
            },
        ]
    },
    {
        item: "footer",
        data: {
            linkTitle: "الروابط",
            addressSection: "طرق الاتصال بنا",
            namadText: "علامات الثقة",
            emailText: "البريد الإلكتروني",
            followText: "تابعنا على وسائل التواصل الإجتماعي.",
            link1: 'مجلة الصحة',
            link2: 'معلومات عنا',
            link3: 'منتجات',
            link4: 'اتصل بنا',
            link5: 'الصفحة الأصلية',
            link1Href: '/articels',
            link2Href: '/ar/AboutUs',
            link3Href: '/products',
            link4Href: '/ar/ContactUs',
            link5Href: '/ar',
            loadingText: 'في الحال...',
        }
    },
    {
        item: "header",
        data: {
            mainTitle: "المكسرات الحسن پور",
            slogan: "مع أكثر من 60 عامًا من الخبرة الرائعة في صناعة المكسرات",
            searchText: "بحث منتوج",
            lang: "لغة",
            accountBtn: "الحساب",
        }
    },
    {
        item: "homepage",
        data: {
            mainTitle: "المكسرات الحسن پور",
            slogan: "مع أكثر من 60 عامًا من الخبرة الرائعة في صناعة المكسرات",
            searchText: "بحث منتوج",
            bestSalesTitle: "أفضل المنتجات مبيعًا ",
            instaboxText: "تابع صفحتنا على Instagram ",
            magBoxtitle: "الحياة السعيدة تعتمد على جسد سعيد ",
            magBoxSecondTitlte: "نأتي لكم بأحدث المواد الخام",
            articelsBoxTitle: "مجلة الصحة",
            newestBoxTitle: "أحدث المنتجات",
        }
    },
    {
        item: "productList",
        data: {
            mainCatTitle: "تصنيف المنتجات ",
            subCat: 'الفئات الفرعية',
            sortText: 'ترتيب',
            searchText: "بحث منتوج",
            searchTitleText: 'بحث',
            ascSort: 'تصاعدي',
            desSort: 'تنازلي ',
            emptyProducts: 'لم يتم العثور على العناصر',
            rangeSelectTitle: 'النطاق السعري المستهدف',
            loadingText: 'جار التحميل',
        }
    },
    {
        item: "articlesList",
        data: {
            mainCatTitle: "التجمع",
            searchText: "بحث منتوج",
            searchTitleText: 'بحث',
            emptyArticels: 'لا توجد مقالات في هذه الفئة',
            loadingText: 'جار التحميل',
        }
    },
    {
        item: "aboutUs",
        data: {
            title: "معلومات عنا ",
            aboutText: "حول المكسرات الحسن پور",
            faqsTitle: "أسئلة مكررة",
            whyText: "لماذا المكسرات الحسن پور؟",
        }
    },
    {
        item: "contactUs",
        data: {
            title: "اتصل بنا",
            address: "تبوك",
            workTime: "ساعات العمل",
            telephone: "هاتف",
            email: "البريد الإلكتروني",
            storePlace: "موقع المتجر",
            fullname: "الاسم الأول واسم العائلة",
            tel: "رقم الهاتف الجوال",
            msg: "رسالة نصية",
            limit: "*160 حرفًا كحد أقصى",
            send: "إرسال"
        }
    },
    {
        item: "productDetail",
        data: {
            propertiesTitle: "ملكيات",
            related: "منتجات مماثلة ",
            selectWeight: "اختيار الوزن",
            package1Title: "250 جرام",
            package2Title: "500 جرام",
            package3Title: "1000 جرام",
            outOfStockSelectedWeight: "غير متوفر. ",
            outOfStock: "هذا المنتج غير متوفر.",
        }
    },
    {
        item: "articleDetail",
        data: {
            mainCatTitle: 'مقالات الفئة',
            date: "نشرت في",
            who: 'بواسطة',
            short: 'خلاصة',
            text: 'نص المقال',
            share: 'المادة تقاسم'
        }
    },
    ]
}
];
export function staticTextLoader(targetItem, lang = localStorage.getItem("lang")) {
    const allTexts = texts.find(dataObj => dataObj.lang === lang)
    if (!targetItem)
        return allTexts || null
    if (allTexts) {
        const tItemData = allTexts.data.find(textData => textData.item === targetItem)
        return (tItemData) ? tItemData.data : null
    }
    return null
}
//not clean
// export function staticTextLoader(targetItem, lang) {
//     const allTexts = texts.find(dataObj => dataObj.lang === lang)
//     if (targetItem === '') {
//         return allTexts || []
//         if (allTexts)
//             return allTexts;
//         else
//             return [];
//     }
//     if (allTexts) {
//         const tItemData = allTexts.data.find(textData => textData.item === targetItem)
//         if (tItemData)
//             return tItemData.data;
//     }
//     return '';
// }